// extracted by mini-css-extract-plugin
export default {"container":"yo-z","brandName":"zo-z","productName":"Ao-z","productNamePdpEnhancements":"Bo-z","breakLongProductName":"Co-z"};